// Colors are kept in-app rather than added to core since this is an experiment
// and we're not sure if this feature will live. We want to roll out fast.
export const TRAVEL_SHIFTS_BANNER_GRADIENT = "linear-gradient(135deg, #FBF2E8 15%, #B7DDFF 97%)";
export const TRAVEL_SHIFTS_BOTTOM_SHEET_GRADIENT = "linear-gradient(to bottom, #FAF8F7, #E2F1FF)";

export const TRAVEL_SHIFTS_LOCAL_STORAGE_KEY_PREFIX = "travel-shifts-response";

export const TRAVEL_SHIFTS_RESPONSES = {
  INTERESTED: "INTERESTED",
  NOT_INTERESTED: "NOT_INTERESTED",
} as const;

export type TravelShiftsResponse =
  (typeof TRAVEL_SHIFTS_RESPONSES)[keyof typeof TRAVEL_SHIFTS_RESPONSES];

export function getTravelShiftsStorageKey(workerId: string): string {
  return `${TRAVEL_SHIFTS_LOCAL_STORAGE_KEY_PREFIX}-${workerId}`;
}
